export default class {
  static ACTIVE = 'ACTIVE';
  static UPCOMING = 'UPCOMING';
  static FINISHED = 'FINISHED';
}
